export default interface DigitalDocumentPromissoryNoteFormModel {
  quota: number;
  repaymentDate: string;
  idIssuer: string;
  options: PromissoryNoteOptionEnum[];
}

export enum PromissoryNoteOptionEnum {
  LostRentedVehicle = 1,
  RepaymentOfRentArrearsDueToSalary = 2
}
